import { Button } from "@/components/ui";
import { TooltipWrapper } from "@/components/ui/shadcn/Tooltip/TooltipWrapper";
import { cn } from "@/lib/utils/cn";
import { Star } from "lucide-react";

type ContactPrimaryStarButtonProps = {
  isPrimary: boolean;
  disabled?: boolean;
  onClick: () => void;
  ariaLabelSet?: string;
  ariaLabelCurrent?: string;
  className?: string;
};

export function ContactPrimaryStarButton({
  isPrimary,
  disabled,
  onClick,
  ariaLabelSet = "Set as primary",
  ariaLabelCurrent = "Primary",
  className,
}: ContactPrimaryStarButtonProps) {
  return (
    <TooltipWrapper message={isPrimary ? "Primary" : "Set as primary"}>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className={cn("shrink-0", className)}
        disabled={disabled}
        onClick={onClick}
        aria-pressed={isPrimary}
        aria-label={isPrimary ? ariaLabelCurrent : ariaLabelSet}
      >
        <Star
          className={cn(
            "h-5 w-5",
            isPrimary
              ? "fill-amber-500 text-amber-500"
              : "text-muted-foreground",
          )}
        />
      </Button>
    </TooltipWrapper>
  );
}
